
var path = '/CulturalResourceGroup/'

function put (http, culturalResourceDto) {
    return http.put(path, culturalResourceDto)
}

function get (http, culturalResourceGroupId) {
    return http.get(path + 'Get?culturalResourceGroupId=' + culturalResourceGroupId)
}

function search (http, searchDto) {
    return http.post(path + 'Search', searchDto)
}

function remove (http, id) {
    return http.post(path + 'Remove?culturalResourceGroupId=' + id)
}

/*** Change functions are for changes to the group that need to go through QA, and are connected to a site form ***/
// function putChange (http, culturalResourceChangeDto) {
//     return http.put(path + 'putChange', culturalResourceChangeDto)
// }

// function getChange (http, culturalResourceGroupChangeId) {
//     return http.getChange(path + 'GetChange?culturalResourceGroupChangeId=' + culturalResourceGroupChangeId)
// }

// function searchChange (http, searchChangeDto) {
//     return http.post(path + 'SearchChange', searchChangeDto)
// }

// function removeChange (http, id) {
//     return http.post(path + 'RemoveChange?culturalResourceGroupId=' + id)
// }

export default {
    get: get,
    put: put,
    search: search,
    remove: remove

    // putChange: putChange,
    // getChange: getChange,
    // searchChange: searchChange,
    // removeChange: removeChange
}




// WEBPACK FOOTER //
// ./src/services/culturalResourceGroupService.js